import LanguagePicker from "../../components/LanguagePicker/LanguagePicker";
import LogInForm from "../../components/LogInForm/LogInForm";
import styles from "./LogIn.module.scss";
import logo from "../../assets/logo.png";
import { useState } from "react";
import CreatePasswordForm from "../../components/CreatePasswordForm/CreatePasswordForm";
import LogInEmailForm from "../../components/LogInEmailForm/LogInEmailForm";
import LogInCodeForm from "../../components/LogInCodeForm/LogInCodeForm";

type LogInStep = "email" | "password" | "code";

const LogInPage = () => {
  const [firstLogin, setFirstLogin] = useState(false);
  const [logInStep, setLogInStep] = useState<LogInStep>("email");
  const [logInEmail, setLogInEmail] = useState("");
  const [codeLogIn, setCodeLogIn] = useState({ loginTicket: "", emailMasked: "" });

  // Email first, then today's password form or the email-code form
  const renderLogInStep = () => {
    if (logInStep === "password") {
      return <LogInForm setFirstLogin={setFirstLogin} email={logInEmail} onChangeEmail={() => setLogInStep("email")} />;
    }
    if (logInStep === "code") {
      return (
        <LogInCodeForm
          email={logInEmail}
          loginTicket={codeLogIn.loginTicket}
          emailMasked={codeLogIn.emailMasked}
          onChangeEmail={() => setLogInStep("email")}
        />
      );
    }
    return (
      <LogInEmailForm
        initialEmail={logInEmail}
        onPasswordMethod={(email) => {
          setLogInEmail(email);
          setLogInStep("password");
        }}
        onCodeMethod={(email, loginTicket, emailMasked) => {
          setLogInEmail(email);
          setCodeLogIn({ loginTicket, emailMasked });
          setLogInStep("code");
        }}
      />
    );
  };

  return (
    <div className={styles.root}>
      <div className={styles.root_border}>
        <LanguagePicker className={styles.root_picker} border={true} />
      </div>
      <div className={styles.root_form}>
        <img className={styles.root_logo} src={logo} alt="Fortect logo" />
        {!firstLogin ? renderLogInStep() : <CreatePasswordForm setFirstLogin={setFirstLogin} />}
      </div>
      <div style={{ position: "absolute", opacity: 0.01 }}>12.03</div>
    </div>
  );
};

export default LogInPage;
